<div class="h-screen mt-8 rounded">

    <div class="flex flex-col items-center justify-center min-h-[70vh] px-4">
        <div class="bg-white shadow-lg rounded-2xl p-8 w-full max-w-xl text-center">

            <div class="flex justify-center mb-4">
                <div class="bg-green-100 p-4 rounded-full">
                    <svg class="w-10 h-10 text-green-600" fill="none" stroke="currentColor" stroke-width="2"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
            </div>

            <h1 class="text-2xl font-bold mb-2">Subscription Activated</h1>
            <p class="text-gray-600 mb-6">
                Your payment setup was successful! Below are your subscription details:
            </p>

            <!-- Subscription Details -->
            <div class="bg-gray-50 p-4 rounded-xl text-left space-y-2">
                <div class="flex justify-between">
                    <span class="font-medium">Plan</span>
                    <span>{{ subscription?.planName }}</span>
                </div>

                <div class="flex justify-between">
                    <span class="font-medium">Amount</span>
                    <span>{{ subscription?.amount }}</span>
                </div>

                <div class="flex justify-between">
                    <span class="font-medium">Billing Cycle</span>
                    <span>{{ subscription?.interval }}</span>
                </div>

                <div class="flex justify-between">
                    <span class="font-medium">Current Billing End</span>
                    <span>{{ subscription?.currentPeriodEnd | moment:'dd MM YYYY' }}</span>
                </div>

                <div class="flex justify-between">
                    <span class="font-medium">Payment Method</span>
                    <span>**** {{ subscription?.cardLast4 }}</span>
                </div>
            </div>

            <button class="mt-8 px-6 py-3 bg-blue-600 text-white rounded-xl shadow-md hover:bg-blue-700 transition"
                (click)="goToDashboard()">
                Go to Dashboard
            </button>
        </div>
    </div>

</div>